import styled from "styled-components/macro";

import FnrIcon from "UI/FnrIcon";

import { useCTAContext } from "./CTA";

export const ActionButton = ({ action }) => {
  return (
    <ActionButtonLayout>
      <Action>
        <div>{action}</div>
        <FnrIcon fas fa-chevron-double-right />
      </Action>
    </ActionButtonLayout>
  );
};

export const ActionButtonLayout = ({ children }) => {
  const { isHovering, isAdmin, isPreview } = useCTAContext();

  return (
    <ActionButtonWrapper
      $showHoverState={isHovering && !(isAdmin || isPreview)}
    >
      {children}
    </ActionButtonWrapper>
  );
};

const Action = styled.div`
  text-transform: uppercase;
  font-weight: 600;
  display: flex;
  align-items: center;
  font-size: 14px;
  gap: 6px;
  justify-content: flex-end;
  padding: 0 16px;
`;
const ActionButtonWrapper = styled.div`
  border-top: 2px solid rgba(255, 255, 255, 0.4);
  background: rgba(255, 255, 255, 0.1);
  width: 100%;
  border-radius: 0 0 24px 24px;
  position: absolute;
  bottom: ${({ $showHoverState }) => ($showHoverState ? "-8px" : "0px")};
  left: ${({ $showHoverState }) => ($showHoverState ? "-8px" : "0px")};
  padding: ${({ $showHoverState }) =>
    $showHoverState ? "8px 8px 20px 8px" : "12px 0 12px 0"};
  transition: all 0.18s ease;
`;
